import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, ControlLabel, FormControl, Button } from 'react-bootstrap';
import moment from 'moment';
import DateTime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import './FormDateTime.css';

export default class FormDateTime extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  onChange(time) {
    console.log(time);
    return this.props.input.onChange(time.toISOString());
  }

  onClick(time) {
    return this.onChange(time);
  }

  onNext(hour, min) {
    const now = moment();
    const a = moment().hour(10).minute(30);
    const b = moment().add(1, 'd').hour(hour).minute(min);
    this.onClick(a.isBefore(now) ? b : a);
  }
  render() {
    const { label, input, controlId } = this.props;

    return (
      <FormGroup controlId={controlId || ''}>
        <ControlLabel>{label}</ControlLabel>
        <div style={{ flexDirection: 'row', display: 'flex' }}>
          <DateTime value={input.value} dateFormat onChange={this.onChange} />
          <Button
            className="button-secondary form-datetime-option-button"
            type="button" onClick={() => this.onClick(moment())}
          >Now</Button>
          <Button
            className="button-secondary form-datetime-option-button"
            type="button"
            onClick={() => this.onNext(10, 0)}
          >10:00 AM</Button>
          <Button
            className="button-secondary form-datetime-option-button"
            type="button"
            onClick={() => this.onNext(10, 30)}
          >10:30 AM</Button>
          <Button
            className="button-secondary form-datetime-option-button"
            type="button"
            onClick={() => this.onNext(11, 0)}
          >11:00 AM</Button>
          <Button
            className="button-secondary form-datetime-option-button"
            type="button"
            onClick={() => this.onNext(11, 30)}
          >11:30 AM</Button>
        </div>
        <FormControl.Feedback />
      </FormGroup>
    );
  }
}

FormDateTime.propTypes = {
  label: PropTypes.string,
  controlId: PropTypes.string,
  input: PropTypes.object,
  copy: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/cms/form/FormDateTime.js